export const groupSessionKeys = {
    all: ['groupSession'] as const,
    list: (centerId: string) => ['groupSession', 'list', centerId] as const,
    detail: (sessionId: string) => ['groupSession', 'detail', sessionId] as const,
};
